import React from 'react';
// import { Link } from 'react-router-dom';
// import style from './style.css';
//import FontAwesome from 'react-fontawesome';
import { ProfileThumb } from '../../Common/CardComponents';
import { gtmSend } from '../../../helpers';
import { translate } from 'react-i18next';
import cx from '../../../styles';

const ReplyInput = ({ clickHandler, user, t, cardName, match}) => {
    const handleReplyBoxClick = () => {
        if(cardName) {
            gtmSend('dynamic', cardName, 'click-reply-box', match.path)
        }
    }

    return (
        <div className={cx("post-reply")}>
            <div>
                <ProfileThumb img={user.image ? user.image : ""} altName={`${user.fullname} profile icon`} />
            </div>
            <div className={cx("reply-input-text")} onClick={() => handleReplyBoxClick()}>
                <span onClick={() => clickHandler()}>{t('detail_reply_placeholder')}</span>
            </div>
        </div>
    );
};

export default translate()(ReplyInput);
